export default [ '$locationProvider', '$logProvider', '$sceDelegateProvider', '$compileProvider', '$httpProvider', function ($locationProvider, $logProvider, $sceDelegateProvider, $compileProvider, $httpProvider) {
    /* istanbul ignore next */
    var envIsNotProd = (window.location.host.indexOf('local') >= 0) || (window.location.host.indexOf('www-dev') >= 0) || (window.location.host.indexOf('www-it') >= 0);

    $logProvider.debugEnabled(envIsNotProd);

    $compileProvider.debugInfoEnabled(envIsNotProd);

    let smsWhiteList = /^\s*(https?|ftp|mailto|tel|file|sms|tel):/;
    $compileProvider.aHrefSanitizationWhitelist(smsWhiteList);

    //got a JSONP or other CORS issue? This would be the place to add it. Please check with someone first though...
    $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        /https?\:\/\/[^\.]*\.?contactatonce\.com\/.*$/
    ]);

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false,
        rewriteLinks: false
    }).hashPrefix('?');

    //Sets default timeout of 15 sec on $http calls
    $httpProvider.interceptors.push(() => {
        return {
            request: (config) => Object.assign({ timeout: 15000 }, config)
        };
    });

}];
